<p-toast></p-toast>

<div class="flex-1 flex items-center justify-between w-full">
  <!-- Left Side: Controls & Breadcrumb -->
  <div class="flex items-center gap-3">
    <!-- Desktop Toggle -->
    <p-button [text]="true" [unstyled]="true" [rounded]="true" (onClick)="toggleSidebar.emit()"
      class="hidden md:inline-block"
      styleClass="flex items-center justify-center w-8 h-8 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 cursor-pointer active:scale-95 transition-all outline-none border-none bg-transparent"
      [attr.aria-label]="isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <i class="pi" [ngClass]="isSidebarCollapsed ? 'pi-align-left' : 'pi-align-justify'"></i>
    </p-button>

    <!-- Mobile Toggle -->
    <p-button [text]="true" [unstyled]="true" [rounded]="true" (onClick)="toggleMobile.emit()"
      class="inline-block md:hidden"
      styleClass="flex items-center justify-center w-8 h-8 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 cursor-pointer active:scale-95 transition-all outline-none border-none bg-transparent"
      [attr.aria-label]="mobileOpen ? 'Close navigation menu' : 'Open navigation menu'">
      <i class="pi pi-bars text-sm"></i>
    </p-button>

    <!-- Test Environment Badge -->
    @if (isTestEnvironment) {
    <span
      class="ml-2 px-2.5 py-0.5 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 text-xs font-semibold tracking-wider uppercase rounded shrink-0 inline-flex items-center gap-1.5"
      [title]="'Base API: ' + apiUrl">
      <i class="pi pi-cloud text-slate-500 dark:text-slate-400 text-[10px]"></i>
      <span>Test Env</span>
    </span>
    }
  </div>

  <!-- Right Side: Quick Info & User Dropdown -->
  <div class="flex items-center gap-2 sm:gap-3">
    <!-- Theme Switcher -->
    <p-button [text]="true" [rounded]="true" (onClick)="themeService.toggleTheme()"
      styleClass="w-8 h-8 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 flex items-center justify-center cursor-pointer transition-all outline-none border-none bg-transparent"
      [attr.aria-label]="themeService.currentTheme() === 'light' ? 'Switch to dark theme' : 'Switch to light theme'">
      <i class="pi text-base" [ngClass]="themeService.currentTheme() === 'light' ? 'pi-moon' : 'pi-sun'"></i>
    </p-button>

    <!-- Notifications Widget -->
    <p-button [text]="true" [rounded]="true"
      styleClass="relative w-8 h-8 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 flex items-center justify-center cursor-pointer transition-all outline-none border-none bg-transparent"
      aria-label="View notifications">
      <i class="pi pi-bell text-base"></i>
      <span
        class="absolute top-2 right-2 w-1.5 h-1.5 bg-blue-600 border border-white dark:border-slate-900 rounded-full"></span>
    </p-button>

    <div class="h-5 w-px bg-slate-200 dark:border-slate-800 mx-0.5"></div>

    <!-- User Profile Dropdown -->
    <div class="relative" (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()">
      <p-button [text]="true" (onClick)="showDropdown()"
        styleClass="flex items-center gap-2.5 px-2.5 py-1 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 transition-all cursor-pointer outline-none border-none bg-transparent"
        aria-haspopup="true" [attr.aria-expanded]="dropdownOpen">
        <div
          class="w-8 h-8 rounded-md bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-800 dark:text-slate-200 font-semibold text-xs border border-slate-200 dark:border-slate-700">
          {{ userInitials() }}
        </div>
        <div class="hidden sm:flex flex-col text-left">
          <span class="text-[13px] font-medium text-slate-800 dark:text-slate-200 leading-tight">{{ userFullName()
            }}</span>
          <span class="text-[11px] text-slate-500 dark:text-slate-400 leading-none">{{ userRoleName() }}</span>
        </div>
        <i class="pi pi-chevron-down text-[9px] text-slate-400 dark:text-slate-500"></i>
      </p-button>

      <!-- Dropdown Panel -->
      @if (dropdownOpen) {
      <div class="absolute right-0 pt-1.5 z-30">
        <div
          class="w-52 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-lg py-1.5 transition-all">
          <a href="#" (click)="$event.preventDefault()"
            class="flex items-center gap-2.5 px-3.5 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white transition-colors">
            <i class="pi pi-user text-slate-400 dark:text-slate-500 text-sm"></i>
            <span>My Profile</span>
          </a>
          <a [routerLink]="['/account-settings']" (click)="hideDropdown()"
            class="flex items-center gap-2.5 px-3.5 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white transition-colors">
            <i class="pi pi-cog text-slate-400 dark:text-slate-500 text-sm"></i>
            <span>Account Settings</span>
          </a>
          <button type="button" (click)="openSwitchOrgModal()"
            class="w-full flex items-center gap-2.5 px-3.5 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white transition-colors cursor-pointer border-none bg-transparent text-left outline-none">
            <i class="pi pi-building text-slate-400 dark:text-slate-500 text-sm"></i>
            <span>Switch Organization</span>
          </button>
          <div class="border-t border-slate-100 dark:border-slate-800 my-1"></div>
          <p-button [text]="true" (onClick)="logout()" [severity]="'danger'"
            styleClass="w-full flex items-center gap-2.5 px-3.5 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50/70 dark:hover:bg-red-950/30 transition-colors cursor-pointer text-left border-none bg-transparent outline-none">
            <i class="pi pi-power-off text-red-500 text-sm"></i>
            <span>Sign Out</span>
          </p-button>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<!-- Switch Organization Dialog Modal -->
<p-dialog [(visible)]="displaySwitchOrgModal" [modal]="true" [header]="'Switch Organization'"
  [style]="{ width: '420px' }" styleClass="dark:bg-slate-900 dark:text-slate-100 rounded-lg overflow-hidden shadow-xl"
  [draggable]="false" [resizable]="false" [dismissableMask]="true">

  <div class="p-1 space-y-3">
    <p class="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
      Select an organization to switch your active working context.
    </p>

    @if (loadingOrganizations()) {
    <div class="space-y-2 py-3">
      <p-skeleton height="2.75rem" styleClass="rounded-md"></p-skeleton>
      <p-skeleton height="2.75rem" styleClass="rounded-md"></p-skeleton>
    </div>
    } @else if (userOrganizations().length === 0) {
    <div class="py-6 text-center text-sm text-slate-400 dark:text-slate-500 flex flex-col items-center gap-2">
      <i class="pi pi-building text-2xl text-slate-300 dark:text-slate-600"></i>
      <span>No associated organizations found.</span>
    </div>
    } @else {
    <div class="space-y-2 max-h-60 overflow-y-auto pr-1">
      @for (org of userOrganizations(); track org.id) {
      <div (click)="selectOrg(org)" [ngClass]="{
              'border-slate-900 bg-slate-100/90 dark:border-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white font-medium': selectedOrg()?.id === org.id,
              'border-slate-200 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/60 text-slate-700 dark:text-slate-300': selectedOrg()?.id !== org.id
            }" class="flex items-center justify-between p-3 rounded-md border transition-all cursor-pointer group">
        <div class="flex items-center gap-3">
          <div
            class="w-8 h-8 rounded-md bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-500 dark:text-slate-400 group-hover:text-slate-900 dark:group-hover:text-white transition-colors shrink-0">
            <i class="pi pi-building text-sm"></i>
          </div>
          <div class="flex flex-col">
            <span class="text-sm font-semibold tracking-tight">{{ org.name }}</span>
            <span class="text-xs text-slate-400 dark:text-slate-500">{{ org.code }}</span>
          </div>
        </div>

        @if (selectedOrg()?.id === org.id) {
        <i class="pi pi-check-circle text-slate-900 dark:text-white text-base"></i>
        }
      </div>
      }
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 pt-3 border-t border-slate-100 dark:border-slate-800">
      <p-button label="Cancel" [text]="true" severity="secondary" (onClick)="displaySwitchOrgModal = false"
        styleClass="text-sm font-medium px-4 py-2 rounded-md text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 border-none cursor-pointer"></p-button>
      <p-button label="Switch Organization" icon="pi pi-sync" [loading]="switchingOrg()"
        [disabled]="!selectedOrg() || switchingOrg()" (onClick)="confirmSwitchOrganization()"
        styleClass="bg-slate-900 hover:bg-slate-800 dark:bg-white dark:hover:bg-slate-100 text-white dark:text-slate-900 text-sm font-medium px-4 py-2 rounded-md border-none transition-all cursor-pointer disabled:opacity-50"></p-button>
    </div>
  </ng-template>
</p-dialog>